import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { BehaviorSubject, Observable } from 'rxjs'

// Backs the stepper shell's aria-live="polite" region (story e8-1 AC8 — "Step N of M"
// announcement on every step change). A single instance is shared across every step
// the shell ever renders, so future e8-2+ steps get this for free.
@Injectable({ providedIn: 'root' })
export class ServicePlanStepAnnouncerService {
  private messageSubject = new BehaviorSubject<string>('')
  public message$: Observable<string> = this.messageSubject.asObservable()

  constructor(private translate: TranslateService) {}

  announceStep(current: number, total: number, titleKey: string): void {
    this.translate.get(titleKey).subscribe((title) => {
      this.translate
        .get('SERVICE_PLAN.STEP_INDICATOR', { current, total, title })
        .subscribe((message) => this.messageSubject.next(message))
    })
  }

  announceMessage(message: string): void {
    this.messageSubject.next(message)
  }

  clear(): void {
    this.messageSubject.next('')
  }
}
